
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"19","viewBox":"0 0 43 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.544 18.048c0-5.536.992-9.872 2.976-13.008C5.536 1.904 8.864.336 13.504.336s7.952 1.568 9.936 4.704c2.016 3.136 3.024 7.472 3.024 13.008 0 5.568-1.008 9.936-3.024 13.104-1.984 3.168-5.296 4.752-9.936 4.752S5.536 34.32 3.52 31.152C1.536 27.984.544 23.616.544 18.048zm19.296 0c0-2.368-.16-4.352-.48-5.952-.288-1.632-.896-2.96-1.824-3.984-.896-1.024-2.24-1.536-4.032-1.536-1.792 0-3.152.512-4.08 1.536-.896 1.024-1.504 2.352-1.824 3.984-.288 1.6-.432 3.584-.432 5.952 0 2.432.144 4.48.432 6.144.288 1.632.896 2.96 1.824 3.984.928.992 2.288 1.488 4.08 1.488 1.792 0 3.152-.496 4.08-1.488.928-1.024 1.536-2.352 1.824-3.984.288-1.664.432-3.712.432-6.144zM30.76 7.2V1.008h11.567V36h-6.912V7.2H30.76z","fill":"#000"}})])
          )
        }
      }
    